module.exports = "<div>\n\t<div class=\"mya-section-info\">\n\t\t<div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.delete_account.title\"></div>\n\t\t<div class=\"text-m mt5 mb10 text-grey-3\" translate=\"cw.my_account.delete_account.desc\" translate-values=\"{brandname : brandName}\"></div>\n\t\t<a class=\"text-l crs-pointer text-red-2\" ng-click=\"deleteAccountCtrl.deleteAccount()\" translate=\"cw.my_account.delete_account.btn\"></a>\n\t</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/my-account/data-settings/delete-account/delete-account.html
// module id = q8ap
// module chunks = 0